import React from 'react';
import { Box, Container, Typography, Stack, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import SearchIcon from '@mui/icons-material/Search';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

const steps = [
  {
    number: '01',
    icon: <ChatBubbleOutlineIcon sx={{ fontSize: 36, color: '#38BDF8' }} />,
    title: 'Conversamos',
    description:
      'Nos cuentas cómo opera tu negocio hoy: qué procesos manejas, qué problemas tienes, qué quisieras mejorar. Sin tecnicismos, sin compromisos.',
  },
  {
    number: '02',
    icon: <SearchIcon sx={{ fontSize: 36, color: '#38BDF8' }} />,
    title: 'Analizamos',
    description:
      'Estudiamos tu operación a fondo. Identificamos los puntos de dolor y diseñamos una solución específica para tu realidad, no una plantilla genérica.',
  },
  {
    number: '03',
    icon: <RocketLaunchIcon sx={{ fontSize: 36, color: '#38BDF8' }} />,
    title: 'Construimos',
    description:
      'Desarrollamos e implementamos tu solución. Te acompañamos en cada etapa y ajustamos lo que necesites hasta que funcione exactamente como lo necesitas.',
  },
];

const ProcessSection = () => {
  return (
    <Box id="process" sx={{ bgcolor: '#F4F4F5', py: { xs: 8, md: 12 } }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Typography
            variant="overline"
            display="block"
            align="center"
            sx={{ color: '#38BDF8', fontWeight: 700, letterSpacing: 3, mb: 1 }}
          >
            CÓMO TRABAJAMOS
          </Typography>
          <Typography
            variant="h3"
            align="center"
            sx={{ fontWeight: 800, color: '#083a94', mb: 2, fontSize: { xs: '2rem', md: '2.6rem' } }}
          >
            Simple, directo y a tu medida
          </Typography>
          <Typography
            align="center"
            sx={{ color: '#555', maxWidth: 560, mx: 'auto', mb: 8, fontSize: '1.05rem' }}
          >
            Nuestro proceso garantiza que la solución que recibas sea exactamente
            la que tu negocio necesita.
          </Typography>
        </motion.div>

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          alignItems="stretch"
        >
          {steps.map((step, i) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              style={{ flex: 1 }}
            >
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  height: '100%',
                  border: '1px solid #E5E7EB',
                  borderRadius: 3,
                  position: 'relative',
                  transition: 'box-shadow 0.3s, transform 0.3s',
                  '&:hover': {
                    boxShadow: '0 12px 40px rgba(8,58,148,0.1)',
                    transform: 'translateY(-4px)',
                  },
                }}
              >
                {/* Número decorativo */}
                <Typography
                  sx={{
                    position: 'absolute',
                    top: 16,
                    right: 20,
                    fontSize: '4rem',
                    fontWeight: 900,
                    color: 'rgba(8,58,148,0.06)',
                    lineHeight: 1,
                    userSelect: 'none',
                  }}
                >
                  {step.number}
                </Typography>

                <Box sx={{ mb: 2 }}>{step.icon}</Box>
                <Typography variant="h5" sx={{ fontWeight: 700, color: '#083a94', mb: 1.5 }}>
                  {step.title}
                </Typography>
                <Typography sx={{ color: '#555', lineHeight: 1.7 }}>
                  {step.description}
                </Typography>

                {/* Conector entre pasos */}
                {i < steps.length - 1 && (
                  <Box
                    sx={{
                      display: { xs: 'none', md: 'block' },
                      position: 'absolute',
                      right: -20,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: '#38BDF8',
                      fontSize: '1.5rem',
                      zIndex: 1,
                    }}
                  >
                    →
                  </Box>
                )}
              </Paper>
            </motion.div>
          ))}
        </Stack>
      </Container>
    </Box>
  );
};

export default ProcessSection;
